// extracted by mini-css-extract-plugin
export default {"spanTitle":"classes_spanTitle__wHhUJ","dot":"classes_dot__P7o5J"};